import { useCallback, useState } from 'react';
import { useHttpClientsContext } from '../../../context/HttpClientsContext';

export const useUoUBusinessData = () => {
  const [imageUrl, setImageUrl] = useState<string>('');
  const [businessName, setBusinessName] = useState<string>('');
  const [assistantName, setAssistantName] = useState<string>('');
  const { chatClient } = useHttpClientsContext();

  const fetchBusinessProperties = useCallback(async () => {
    const { assistantName: assistantNameApi, businessName: businessNameApi, imageUrl: imageUrlApi } = await chatClient.getBusinessProperties();
    setAssistantName(assistantNameApi);
    setBusinessName(businessNameApi);
    setImageUrl(imageUrlApi ?? '');
  }, [chatClient]);

  return {
    imageUrl,
    businessName,
    assistantName,
    fetchBusinessProperties,
  };
};
